export const header: object = {
  header: {
    secureText: 'Sicher',
    returnToSap4me: 'Kehren Sie zu SAP for Me zurück',
    returnToCart: 'Zurück zum Warenkorb',
    aria: {
      returnTo: 'Zurück zu.',
      sapStoreCart: 'SAP Store Warenkorb. Zurück zu.',
      sapStoreCheckout: 'SAP Store Checkout. Zurück zu.',
    }
  }
};
